export default __webpack_public_path__ + "static/media/2_0138.54abc37a.webp";